/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import {useState} from 'react';
import './AddTag.scss';
import Locale from '../util/Locale';
import LoadingIndicator from './LoadingIndicator';
import Badge from './Badge';
import Analytics from '../util/Analytics';

export const MAX_TAG_LENGTH = 50;

export function onTagChange(input, setInput, count, setCount) {
    let validInput = '';
    input.split('').forEach(char => {
        if (
            'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 ,-'.includes(char) &&
            (validInput.length > 0 || char !== ' ')
        ) {
            validInput += char;
        } else {
            setCount(count + 1); // Need to have React update the component's value when it may be the same as previous value
        }
    });
    if (validInput.length > MAX_TAG_LENGTH) {
        validInput = validInput.substr(0, MAX_TAG_LENGTH);
        setCount(count + 1);
    }
    setInput(validInput);
}

// Limit to alphanumerics and the space, comma, and dash symbols.
// Limit to MAX_TAG_LENGTH tag names
// Supress leading spaces.
// Note that we will trim entire tag name when passing to the onAdd prop callback.
//
function onInputHandler(setInput, count, setCount) {
    return event => {
        const input = event.currentTarget.value;
        onTagChange(input, setInput, count, setCount);
    };
}

function renderFooter(props) {
    return (
        <div className="footerActions">
            <nsemble-button
                text
                onClick={() => {
                    props.setShowModal(false);
                }}
            >
                {Locale.getText('CLOSE')}
            </nsemble-button>
        </div>
    );
}

function onAddTag(props, input, setInput, setSaving) {
    return async () => {
        const newInput = input.trim();
        if (props.onAdd && newInput.length) {
            Analytics.trackEvent('Tag', `Add (${newInput})`);
            setSaving(true);
            await props.onAdd(newInput);
            setInput('');
            setSaving(false);
        }
    };
}

function onDeleteHandler(idx, props, setDeleteNth) {
    const callback = props.onDeleteHandler ? props.onDeleteHandler(idx) : () => {};
    return async () => {
        if (props.tags) {
            Analytics.trackEvent('Tag', `Delete from Add Tags modal (${props.tags[idx]})`);
        }
        setDeleteNth(idx);
        await callback(idx); //eslint-disable-line
        setDeleteNth(-1);
    };
}

export default function AddTag(props) {
    const [taginput, setTaginput] = useState(props.tagInput || ''); // Keep track of what's being typed into the text input
    const [changeCount, setChangeCount] = useState(0); // React won't call attributesChanged code when setValue called with same value as last time so...
    const [isSaving, setIsSaving] = useState(false);
    const [deleteNth, setDeleteNth] = useState(-1);
    const disableAddButton = taginput.trim().length === 0 ? {disabled: true} : {};
    const disableInputDuringSaving = isSaving ? {disabled: true} : {};
    const onInput = props.onInput || onInputHandler;

    return (
        <div className="add-tag-modal">
            <div id="modal-header">
                <h1>{Locale.getText('ADD_TAG')}</h1>
            </div>
            <div id="modal-body">
                <div>
                    <div className="add-tag-block">
                        <div className="input-block">
                            <div className="hideMobileDivider" />
                            <nsemble-input
                                name="taginput"
                                value={taginput}
                                changes={`${changeCount}`}
                                onInput={onInput(setTaginput, changeCount, setChangeCount)}
                                {...disableInputDuringSaving}
                            />
                        </div>
                        <LoadingIndicator isLoading={isSaving}>
                            <nsemble-button
                                primary
                                onClick={onAddTag(props, taginput, setTaginput, setIsSaving)}
                                {...disableAddButton}
                            >
                                {Locale.getText('ADD')}
                            </nsemble-button>
                        </LoadingIndicator>
                    </div>
                    <div className="instructions">{Locale.getText('ADD_TAG_INSTRUCTIONS', {max: MAX_TAG_LENGTH})}</div>
                    {props.tags && (
                        <div className="tag-list">
                            {props.tags.map((tag, idx) => (
                                <LoadingIndicator isLoading={deleteNth === idx} key={`${tag}${idx}`}>
                                    <Badge
                                        text={tag}
                                        key={`${tag}${idx}`}
                                        onCloseOverIcon={onDeleteHandler(idx, props, setDeleteNth)}
                                    />
                                </LoadingIndicator>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <div id="modal-footer">{renderFooter(props)}</div>
        </div>
    );
}
